import styled from 'styled-components'

export const LogoWrapper = styled.img`
  width: 100%;
  max-width: 130px;
  margin-bottom: 30px;
  display: block;
  align-self: center;
  cursor: pointer;
`

export const LogoIconWrapper = styled.img`
  width: 100%;
  max-width: 30px;
  display: block;
  cursor: pointer;
`

export default LogoWrapper
